//
//
//
//
//
//
//

export default {
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/load-more/index.vue